import { colors } from "../base/styled/variables.styled";
const whiteColor = colors.neutral000;
const figmaPrimaryColor = colors.brand500;
const focusVisibleOutlineColor = colors.brand300;
const textFocusColor = colors.neutral800;
const textDefaultInactiveColor = colors.neutral600;
const borderDefaultInactiveColor = colors.neutral200;
export const defaultTheme = {
    name: 'light',
    colors: {
        primary: figmaPrimaryColor,
        text: whiteColor,
        textDefaultInactive: textDefaultInactiveColor,
        textDisabled: colors.textDisabledLight,
        textActive: figmaPrimaryColor,
        textOnPrimary: whiteColor,
        textFocus: textFocusColor,
        textHighlightedInactive: textFocusColor,
        border: colors.neutralBorderLight,
        borderDefaultInactive: borderDefaultInactiveColor,
        borderHighlightedInactive: borderDefaultInactiveColor,
        backgroundLight: colors.backgroundLight,
        backgroundCarouselGradient: colors.backgroundLight,
        backgroundHover: colors.backgroundHoverLight,
        focusOutline: focusVisibleOutlineColor,
    },
    fonts: { body: "'Figtree', sans-serif" },
    borderRadius: '4px',
    spacing: { small: '8px', medium: '16px', large: '24px' },
};
export const darkTheme = Object.assign(Object.assign({}, defaultTheme), { name: 'dark', colors: Object.assign(Object.assign({}, defaultTheme.colors), { text: colors.neutralBorderLight, textDefaultInactive: colors.textDefaultInactiveDark, textDisabled: colors.textDisabledDark, textActive: whiteColor, textOnPrimary: whiteColor, textFocus: colors.neutralBorderLight, textHighlightedInactive: colors.textDefaultInactiveDark, border: colors.borderDark, borderDefaultInactive: colors.borderDefaultInactiveDark, borderHighlightedInactive: colors.borderDefaultInactiveDark, backgroundLight: colors.backgroundDark, backgroundCarouselGradient: colors.backgroundDark, backgroundHover: colors.neutralDarkText }) });
//# sourceMappingURL=theme.js.map